import React from "react";
import PropTypes from "prop-types";
import { titleCase } from "../../utils/dataHelpers/formatters";
import TooltipWrapper from "./TooltipWrapper";

/**
 * Expects schema in format:

    const tooltipSchema = [
      // label for the tooltip
      {
        label: true, 
        accessor: "judge",
      },
      // fields for tooltip
      {
        fieldName: "Case events",
        accessor: "caseEvents",
      },
      {
        fieldName: "% above Avg",
        accessor: "caseEvents",
      },
    ];

 */

const Tooltip = (props) => {
  const { active, payload, tooltipSchema } = props;

  if (active) {
    const data = payload[0].payload;
    const labelItem = tooltipSchema.find((item) => item.label);
    const label = data[labelItem.accessor];
    const fields = tooltipSchema.filter((item) => item.fieldName);

    return (
      <TooltipWrapper label={label}>
        {fields.map((item) => {
          const { fieldName, accessor, formatter, hideFieldName } = item;
          const value = data[accessor];
          const cleanValue = formatter ? formatter(value) : value;
          return (
            <div className="chart-tooltip__value-container" key={fieldName}>
              {!hideFieldName && <span>{titleCase(fieldName)}: </span>}
              <span className="chart-tooltip__value">{cleanValue}</span>
            </div>
          );
        })}
      </TooltipWrapper>
    );
  }
  return false;
};

Tooltip.defaultProps = {
  active: false,
  payload: [],
  label: "",
  includePercent: false,
  reverseList: false,
  colorList: true,
};

Tooltip.propTypes = {
  active: PropTypes.bool,
  payload: PropTypes.arrayOf(PropTypes.object),
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  includePercent: PropTypes.bool,
  reverseList: PropTypes.bool,
  colorList: PropTypes.bool,
  tooltipSchema: PropTypes.arrayOf(PropTypes.object),
};

export default Tooltip;
